document.addEventListener('DOMContentLoaded', () => {
	let currentImageIndex = 0;
	let isAnimating = false;
	const nextArrow = document.querySelector('.next-arrow');
	const prevArrow = document.querySelector('.prev-arrow');
	const imageTags = document.querySelectorAll('.guide-card-collapsable-image');
	const capButtons = document.querySelectorAll('.cap-button');
	const instructions = document.querySelectorAll('.instruction');
	const closeSectionBtn = document.querySelectorAll('.close-section-btn');

	const onClickGuideCard = (e) => {
		const guideCardId = e.getAttribute('data-guide-id');
		const guideCard = document.getElementById(`collapsableGuideCard-${guideCardId}`);

		if(!guideCard) return;

		guideCard.classList.toggle('active');
	}

	// Consistent linear sliding animation function
	const slideToIndex = (targetIndex) => {
		if (isAnimating) return;
		
		const from = currentImageIndex;
		const to = targetIndex;
		const goBackward = from > to;
		
		if (from === to) return;
		
		isAnimating = true;
		
		// Deactivate current button
		capButtons[currentImageIndex].classList.remove('active');
		
		// ==== Prepare incoming slides (NO transition) ====
		imageTags[targetIndex].style.transition = 'none';
		imageTags[targetIndex].style.transform = goBackward ? 'translateX(-100%)' : 'translateX(100%)';
		
		instructions[targetIndex].style.transition = 'none';
		instructions[targetIndex].style.transform = goBackward ? 'translateX(-100%)' : 'translateX(100%)';
		
		// Force reflow
		void imageTags[targetIndex].offsetWidth;
		void instructions[targetIndex].offsetWidth;
		
		// Re-enable transition
		imageTags[targetIndex].style.transition = '';
		instructions[targetIndex].style.transition = '';
		
		// ==== Trigger animations ====
		imageTags[currentImageIndex].style.transform = goBackward ? 'translateX(100%)' : 'translateX(-100%)';
		imageTags[targetIndex].style.transform = 'translateX(0)';
		
		instructions[currentImageIndex].style.transform = goBackward ? 'translateX(100%)' : 'translateX(-100%)';
		instructions[targetIndex].style.transform = 'translateX(0)';
		
		// ==== Cleanup ====
		let finished = 0;
		function onEnd(e) {
			if (e.propertyName !== 'transform') return;
			finished += 1;
			
			// Expect 4 transitions: out+in (image + instruction)
			if (finished < 4) return;
			
			// Update current index
			currentImageIndex = targetIndex;
			
			// Activate new button
			capButtons[currentImageIndex].classList.add('active');
			
			// Update navigation button states
			prevArrow.disabled = (currentImageIndex === 0);
			nextArrow.disabled = (currentImageIndex === imageTags.length - 1);
			
			isAnimating = false;
		}
		
		[imageTags[currentImageIndex], imageTags[targetIndex], instructions[currentImageIndex], instructions[targetIndex]].forEach(el =>
			el.addEventListener('transitionend', onEnd, { once: true })
		);
	}

	const onClickCapButton = (e) => {
		const targetIndex = parseInt(e.dataset.capIndex);
		slideToIndex(targetIndex);
	}

	const onClickNextArrow = () => {
		if (currentImageIndex < imageTags.length - 1) {
			slideToIndex(currentImageIndex + 1);
		}
	}

	const onClickPrevArrow = () => {
		if (currentImageIndex > 0) {
			slideToIndex(currentImageIndex - 1);
		}
	}

	const cards = document.querySelectorAll('.guide-card');
	cards.forEach((card) => {
		card.addEventListener('click', (e) => onClickGuideCard(e.currentTarget));
	});
	
	capButtons.forEach((button) => {
		button.addEventListener('click', (e) => onClickCapButton(e.currentTarget));
	});
	
	if(nextArrow) {	
		nextArrow.addEventListener('click', (e) => onClickNextArrow(e.currentTarget));
	}
	if(prevArrow) {
		prevArrow.addEventListener('click', (e) => onClickPrevArrow(e.currentTarget));
	}

	if(closeSectionBtn) {
		closeSectionBtn.forEach((button) => {
			button.addEventListener('click', (e) => onClickGuideCard(e.currentTarget));
		});
	}
	
});